import { useEffect } from 'react';
import { StoryMediaQuery } from 'types/story';
import { getMediaQueryBoundaries } from 'common/utils/story-media-query';
import { setEditorSize } from 'admin/actions';

const MediaBoundariesObserver = ({ currentMediaQuery, mediaQuery, setEditorSize: setEditorSizeP }: Props) => {
	useEffect(() => {
		const { min, max } = getMediaQueryBoundaries({
			currentMediaQuery,
			mediaQuery,
		});

		setEditorSizeP({ min, max });
	}, [currentMediaQuery, mediaQuery, setEditorSizeP]);

	return null;
};

type Props = {
	setEditorSize: typeof setEditorSize;
	currentMediaQuery: string;
	mediaQuery: StoryMediaQuery;
};

export default MediaBoundariesObserver;
